import { render, staticRenderFns } from "./index.vue?vue&type=template&id=631a55b2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=631a55b2&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('631a55b2')) {
      api.createRecord('631a55b2', component.options)
    } else {
      api.reload('631a55b2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=631a55b2", function () {
      api.rerender('631a55b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Formcreated/index.vue"
export default component.exports